import moment from "moment"
import { useHistory } from "react-router"
import { IChat } from "../database/AppDatabase"
import { IMChat } from "../models/api/IMChat"
import { IMChatMsg } from "../models/app/IMChatMsg"
import { CHAT_DATE_FORMAT, CHAT_TIME_FORMAT } from "../models/constants"
import { rootStore } from "../StApp"
import { ChatDateComp } from "./ChatDateComp"
import UserImage from "./UserImage"
import UserText from "./UserText"

export const IMChatOverviewItem = (props: { item: IChat }) => {

    const history = useHistory()
    const chatItem = props.item.lastMsg
    const chat = props.item

    function openChat() {

        rootStore.mainStore.setCurrentImChatMeta({
            convStarted: true,
            uid: chat.chatterUid,
            userName: chat.chatterId,
            convStartTime: chat.convStartTime
        })
        history.push('/stapp/imchat')
        rootStore.imChatListStore.markChatRead(chat)
    }

    return (
        <div className='flex-row chat-overview-item' onClick={openChat} >
            <UserImage userName={props.item.chatterId} />
            <div className='flex-column chat-overview-text'>
                <h4 style={{ height: 23 }}>{props.item.chatterId}</h4>
                <div className='flex-row center-align' >
                    {chatItem?.senderUid == rootStore.mainStore.uid ?
                        <span className="material-icons-outlined" style={{color:'gray'}} >
                            reply
                        </span> : null}
                    <UserText text={chatItem?.data ?? 'SayToMe says hello!'} unread={chat.unread} />
                </div>
            </div>
            {chat.unread && <div className='round-chat'></div>}
            <ChatDateComp date={moment(props.item.lastMsgTime).format(CHAT_DATE_FORMAT)}
                time={moment(props.item.lastMsgTime).format(CHAT_TIME_FORMAT)}
            />


        </div>
    )
}